// extracted by mini-css-extract-plugin
export default {"searchBar":"styles_searchBar__pGHdZ","searchBtn":"styles_searchBtn__g0ZRX","newBtn":"styles_newBtn__yAefT","infoSpan":"styles_infoSpan__YVdHs"};